
import { ResourceGrid } from "@/components/resource/ResourceGrid";
import { ResourcesEmpty } from "@/components/resource/ResourcesEmpty";

interface AdminResourcesViewProps {
  resources: any[] | undefined;
}

export const AdminResourcesView = ({ resources }: AdminResourcesViewProps) => {
  return (
    <>
      {!resources?.length ? (
        <ResourcesEmpty isTrainee={false} />
      ) : (
        <>
          <div className="mb-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
            <h2 className="text-lg font-medium">Your Training Resources</h2>
          </div>
          <ResourceGrid resources={resources} isTrainee={false} />
        </>
      )}
    </>
  );
};
